export default "__VITE_ASSET__CEC7lpiu__"